// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"FeatureList_Wrap__nU525","Item":"FeatureList_Item__3JzE-","ItemInnerWrap":"FeatureList_ItemInnerWrap__3FKs2","Details":"FeatureList_Details__1NIaS"};